import { createSlice } from "@reduxjs/toolkit";
import { getInstruction } from "../../api/APIServices";
import { API_STATUS } from "../../constants";

const initialState = {status:API_STATUS.IDEL, instructionData:[]};
const instructionSlice = createSlice({
    name:'instructions',
    initialState,
    reducers:{ },
    extraReducers:(builder)=>{
        builder.addCase(getInstruction.fulfilled, (state, action)=>{
            state.instructionData = action.payload;
            state.status = API_STATUS.IDEL;
        }),
        builder.addCase(getInstruction.pending, (state)=>{
            state.status = API_STATUS.PENDING;
        }),
        builder.addCase(getInstruction.rejected, (state)=>{
            state.status = API_STATUS.ERROR;
        })
    }
});

export const {} = instructionSlice.actions;
export default instructionSlice.reducer;